export default {
  props: {
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    },
    themeColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  }
};